module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"loadingData":"Loading data..."},"de":{"loadingData":"Lade Daten..."}}')
  delete Component.options._Ctor
}
